import React from "react";
import styled from "styled-components";
import Head from "../../../../../component/Head";

const Container = styled.div`
  max-width: 425px;
  font-family: "Open Sans", sans-serif;
  margin: 0 auto;
  position: relative;
  min-height: 100vh;
  z-index: -1;
  height: 100vh;
  iframe {
    width: 100%;
    height: 100vh;
  }
`;

export default function News() {
  return (
    <>
      <Head title="R6G | News" openSans racing />
      <Container>
        {" "}
        <iframe
          title="title"
          className="frame-news"
          src="https://squared-potato.pt/filmes-series/"
          frameborder="0"
        ></iframe>
      </Container>

      {/* <Container className="flex">
        <Header>
          <Icon path={mdiArrowLeft} size={1} onClick={Back} />
          News
        </Header>
        {News ? (
          <section className="section nopad pad100 padt100">
            {News?.map(({ _id, title, date, content, image, link }) => (
              <FilmBlock key={_id} onClick={openNews} value={_id}>
                <div className="overlay"></div>
                <div className="image">
                  <p className="date">
                    <Icon className="mr20" path={mdiCalendarBlank} size={1} />
                    {date}
                  </p>
                  <img src={image} alt={title} />
                  <p className="title">{title}</p>
                </div>
              </FilmBlock>
            ))}
          </section>
        ) : (
          <Wrapper>
            <Spinner animation="border" role="status" className="spinner">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Wrapper>
        )}

        {OpenPopUp && (
          <>
            <PopUpWrapper onClick={closePopUp}> </PopUpWrapper>
            <div>
              <PopUp>
                <Icon
                  className="close"
                  path={mdiClose}
                  size={1}
                  onClick={closePopUp}
                />

                <img src={newsPopUp.image} alt={newsPopUp.title} />
                <div className="container intro">
                  <span className="title">{newsPopUp.title}</span>{" "}
                  <span className="date">
                    <Icon className="mr20" path={mdiCalendarBlank} size={1} />
                    <span>{newsPopUp.date}</span>
                  </span>
                </div>

                {newsPopUp.isReview ? (
                  <Vote className="container vote">
                    <div className="note">
                      <p>Notre note</p>
                      <p className="number">7/10</p>
                    </div>
                    <div className="note">
                      <p>La note des abonnées</p>
                      <p className="number">{VoteMoyenne}/10</p>
                    </div>
                    <div className="star">
                      <p>Donnez votre avis </p>
                      <div>
                        <fieldset class="rating">
                          <label
                            class="full"
                            for="star5"
                            value="5"
                            onClick={ToDb}
                          >
                            <Icon path={mdiStar} size={1} />
                          </label>

                          <label
                            class="full"
                            for="star4"
                            onClick={ToDb}
                            value="4"
                          >
                            <Icon path={mdiStar} size={1} />
                          </label>

                          <label
                            class="full"
                            for="star3"
                            onClick={ToDb}
                            value="3"
                          >
                            <Icon path={mdiStar} size={1} />
                          </label>

                          <label
                            class="full"
                            for="star2"
                            onClick={ToDb}
                            value="2"
                          >
                            <Icon path={mdiStar} size={1} />
                          </label>

                          <label
                            class="full"
                            for="star1"
                            onClick={ToDb}
                            value="1"
                          >
                            <Icon path={mdiStar} size={1} />
                          </label>
                        </fieldset>
                      </div>
                    </div>
                  </Vote>
                ) : (
                  ""
                )}

                <div className="container content">{newsPopUp.content}</div>
              </PopUp>
            </div>
          </>
        )}
      </Container> */}
    </>
  );
}
